export function getdata() {
 	let obj = {
 		headData: [{
 				title: "序号",
 				prop: "xh",
 				width: 80,
 				custom: true,
 			},
 			{
 				title: "附加信息名称",
 				prop: "fujxxmc",
 				width: "160",
 			},
 			{
 				title: "数据类型",
 				prop: "shujlx",
 				width: "100",
 				custom: true,
 			}
 		],
 		options: [{
 			value: '0',
 			label: '文本型'
 		}, {
 			value: '1',
 			label: '数值型'
 		}, {
 			value: '2',
 			label: '日期型'
 		}],
 	}
 	return obj
 }
